import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton, MiCheckbox } from "@miplatform/components";
import {
  BUTTON_VARIANTS,
  ICONS_WEB,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import * as mdi from "@mdi/js";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { CollapsibleIcon } from "../../../../components/CollapsibleIcon/CollapsibleIcon";
import { ItemTemplatePlanMaterial } from "./ItemTemplatePlanMaterial";
import { useItemTemplatePlanAreaViewModel } from "./useItemTemplatePlanAreaViewModel";

export const ItemTemplatePlanArea = ({
  itemTemplate = {},
  checkedAreas,
  openItemTemplateResults,
  handleAddItemTemplatesToAreas = () => null,
  setSelectedItemTemplate,
  selectedItemTemplate,
  setSelectedItems,
  selectedItems,
}) => {
  const { materials, getMaterials, isExpanded, setIsExpanded, isLoading } =
    useItemTemplatePlanAreaViewModel({ itemTemplate });
  const { classes } = useStyles();

  useEffect(() => {
    getMaterials();
  }, []);

  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      setSelectedItemTemplate([itemTemplate]);
    } else {
      setSelectedItemTemplate([]);
      setSelectedItems([]);
    }
  };

  const isAreaSelected = selectedItemTemplate.includes(itemTemplate);

  return (
    <Accordion className={classes.root} expanded={isExpanded} disableGutters>
      <AccordionSummary>
        <Box className={classes.rightActionContainer}>
          {openItemTemplateResults && (
            <MiCheckbox
              handleChange={handleCheckboxChange}
              value={isAreaSelected}
            />
          )}
          <Typography variant={TYPOGRAPHY_VARIANTS.SUBTITLE2}>
            {itemTemplate.planAreaLabel}
          </Typography>
        </Box>
        <Box className={classes.summaryActions}>
          {selectedItemTemplate.includes(itemTemplate) && (
            <MiButton
              title="Add Selected Items"
              variant={BUTTON_VARIANTS.CONTAINED}
              size="small"
              onClick={handleAddItemTemplatesToAreas}
              startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
              disabled={
                selectedItems?.length === 0 || checkedAreas.length === 0
              }
            />
          )}
          <Typography variant="caption" color="primary">
            {`${itemTemplate.builderName} | ${itemTemplate.series} | ${itemTemplate.specLevel}`}
          </Typography>
          <CollapsibleIcon
            isCollapsed={isExpanded}
            onCollapse={() => setIsExpanded((prev) => !prev)}
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {materials.map((material) => (
          <ItemTemplatePlanMaterial
            key={material.id}
            material={material}
            itemTemplate={itemTemplate}
            isLoading={isLoading}
            isAreaSelected={isAreaSelected}
            setSelectedItems={setSelectedItems}
            selectedItems={selectedItems}
            selectedItemTemplate={selectedItemTemplate}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 4,
    marginTop: theme.spacing(2),
    width: "100%",
    border: `1px solid ${theme.palette.grey.accent}`,
    "&::before": {
      content: "none",
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
  rightActionContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  summaryActions: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(2),
  },
}));
